<template>
  <ul class="vp-list-none vp-flex vp-space-x-1">
    <li v-for="(item, index) in data" :key="`attr-${index}`">
      <ProductAttribute :attribute="item.attribute" :option="item.option" />
    </li>
  </ul>
</template>

<script>
import ProductAttribute from "./product-attribute.vue";

export default {
  props: {
    data: Array,
  },
  components: {
    ProductAttribute,
  },
};
</script>
